import React, { useState, FunctionComponent, useEffect, useCallback } from 'react';
import { Presentation } from './presentation';
import { getTvsInfo } from '../../../services/tvs';
import { scrollToTop } from '../../../libs/scrollUtils';
import type { Tv } from '../../../types/tvs';

export const Component: FunctionComponent = () => {
  const [keyword, setKeyword] = useState('');
  const [tvs, setTvs] = useState<Tv[]>([]);
  const [tags, setTags] = useState<string[]>([]);
  const [isLoading, setIsLoading ] = useState(false);
  const [page, setPage] = useState(1);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const initialKeyword = params.get('keyword') || '';
    setKeyword(initialKeyword);
    fetchTvs(initialKeyword);
  }, []);

  useEffect(() => {
    if (isLoading) {
      $('.applicants-loading').show();
    } else {
      $('.applicants-loading').hide();
    }
  }, [isLoading]);

  const fetchTvs = async (kw = '') => {
    try {
      setIsLoading(true);
      const response = await getTvsInfo(kw);
      setTvs(response.tvs);
      setTags(response.tvTags);
      setPage(1);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchSubmit = useCallback(() => {
    const url = keyword ? `/tvs/search?keyword=${encodeURIComponent(keyword)}` : `/tvs`;
    window.history.replaceState(null, '', url);
    fetchTvs(keyword);
  }, [keyword]);

  const handleTagClick = useCallback((tag: string) => {
    const url = tag ? `/tvs/search?keyword=${encodeURIComponent(tag)}` : `/tvs`;
    window.history.replaceState(null, '', url);
    fetchTvs(tag);
    setKeyword(tag);
  }, []);

  const handlePageChange = useCallback(
    (newPage: number) => {
      if (newPage === page) return;
      scrollToTop();
      setPage(newPage);
    },
    [page]
  );

  return (
    <Presentation
      tvs={tvs}
      tvTags={tags}
      keyword={keyword}
      page={page}
      isLoading={isLoading}
      setKeyword={setKeyword}
      handleSearchSubmit={handleSearchSubmit}
      handleTagClick={handleTagClick}
      handlePageChange={handlePageChange}
    />
  );
};
